

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios'
import VueAxios from 'vue-axios'

import dataModule from '@/store/data'

import VeeValidate, {Validator} from 'vee-validate';
import validatorEs from '@/validator/es';
import validatorEn from '@/validator/en';

import messages from '@/translations';


let domain = 'gestion.programaclave.com';
if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1" || window.location.hostname.includes('dev.doubledot.es')) {
  domain = 'https://sandbox-usal.dotia.es';
}

export const store = new Vuex.Store({
  state :{
    language: localStorage.getItem('language') || 'es',
    server: domain
  },
  getters : {
    getLanguage : state => state.language,
    getServer : state => state.server,
    getTexts : state => {
      return messages[state.language];
    }
  },
  modules :{
    dataModule
  }
});




// WEBPACK FOOTER //
// ./src/store/store.js